/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import BannerImage from '../../../components/BannerImage'
import SignIn from './Components/SignIn'
import GlobalContext from '../../../components/Context/GloablContext';
import { Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { logIn } from '../authSlice';

import { useNavigate } from 'react-router-dom';
import TrustBrowser from './Components/TrustBrowser';
import OtpPage from './Components/Otp';
import ForgotPassword from './Components/ForgotPassword';
import SetPreferencesModal from './Components/SetPreferencesModal';
import { userService } from '../../../services/user.services';
// import ForgotPassword from './Components/ForgotPassword';
import maskValue from '../../../CommonMethods/maskedEmailFunction'
import { handleRestrictKey } from '../../../redux/systemConfigSlice';
import refreshIdToken from '../../../CommonMethods/RefreshIdFunction';
import authenticateUser from '../../../config/aws-export';
import DuplicateTabCloseModal from './Components/DuplicateTabCloseModal';
import { syncAuthToLocalStorage, clearAuthData } from '../../../CommonMethods/AuthSync';


export default function LoginPage() {
    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, setIsSideBar, WebSocketConnection,fetchAndCacheHelpGuides } = useContext(GlobalContext)
    const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [userData, setuserData] = useState({});
    const [myInfo, setmyInfo] = useState({})
    const [idToken, setIdToken] = useState("")
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [otp, setOtp] = useState("000000");
    const [timer, setTimer] = useState(30);
    const [duration, setDuration] = useState('')
    const [preferenceLoading, setPreferenceLoading] = useState(false);
    const [isTrustMyBrowser, setIsTrustMyBrowser] = useState(false)

    const [displayOtpScreen, setDisplayOtpScreen] = useState(false)
    const [preferenceModel, setPreferenceModel] = useState(false);
    const [preferenceList, setPreferenceList] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState([]);

    const [duplicateTabModal, setDuplicateTabModal] = useState(false);
    const [dupLoadingBtn, setDupLoadingBtn] = useState(false);
    const [loginData, setLoginData] = useState('')

    const dispactch = useDispatch()
    const [loginCredentials, setloginCredentials] = useState({
        email: '',
        password: ''
    });
    const [resetPassword, setResetPassword] = useState({
        temp_password: '',
        new_password: '',
        confirm_new_password: ''
    });
    const { temp_password, new_password, confirm_new_password } = resetPassword
    const handleResetPasswordCredentilas = (key, value) => {
        setResetPassword((current) => ({
            ...current,
            [key]: value
        }))
    }
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [error, seterror] = useState(false);
    const [emptyError, setEmptyError] = useState(false)
    const navigate = useNavigate()
    const [loginError, setloginError] = useState('')
    const { email, password } = loginCredentials
    const handleLoginCredentilas = (key, value) => {
        if (key === "email") {
            setloginCredentials((current) => ({
                ...current,
                [key]: value.replace(/\s/g, '')
            }))

        } else {
            setloginCredentials((current) => ({
                ...current,
                [key]: value
            }))

        }

    }

    const handelClear = () => {
        setloginCredentials({
            email: '',
            password: ''
        });
        setloginError('')
        seterror(false)
    }


    const handleLogin = async (e, key) => {
        seterror(false)
        e.preventDefault();
        if (key === undefined) {
            setloading(true);
            setOtp(Array(6).fill(""))

        }
        if (key) {
            setTimer(parseInt(duration))
        }
        if (email?.trim() === "" || password?.trim() === "") {
            setEmptyError(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            setloading(false)
            return
        }
        sessionStorage.setItem('email', email);
        const browser_id = localStorage.getItem('arcm_trust_browser_token') ? localStorage.getItem('arcm_trust_browser_token') : ''

        try {
            const loginresponse = await userService.login(email.toLowerCase().trim().replace(/\s/g, ''), password, browser_id);
            setLoginData(loginresponse);
            sessionStorage.setItem('first_name', loginresponse?.data?.first_name);
            sessionStorage.setItem('last_name', loginresponse?.data?.last_name);

            // Check if user has an active session elsewhere
            if (loginresponse?.data?.isLoggedIn === true) {
                // User has an active session elsewhere
                // Persist auth tokens temporarily (before confirmation)
                sessionStorage.setItem('email', email);
                sessionStorage.setItem('IdToken', loginresponse?.data?.IdToken)
                sessionStorage.setItem('currentTimestamp', ((new Date).getTime().toString()))
                sessionStorage.setItem('RefreshToken', loginresponse?.data?.RefreshToken)
                sessionStorage.setItem('AccessToken', loginresponse?.data?.AccessToken)
                sessionStorage.setItem('user_id', loginresponse?.data?.user_id)
                sessionStorage.setItem('id', loginresponse?.data?.id);
                sessionStorage.setItem('user_type', loginresponse?.data?.user_type);
                sessionStorage.setItem('session_token', loginresponse?.data?.session_token);
                sessionStorage.setItem('first_name', loginresponse?.data?.first_name);
                sessionStorage.setItem('last_name', loginresponse?.data?.last_name);
                
                // Sync auth tokens to localStorage for cross-tab access
                syncAuthToLocalStorage();

                // Set preference list if available
                if (loginresponse.data.Preference_list) {
                    setPreferenceList(loginresponse.data.Preference_list);
                }

                // Set restrict and sidebar state
                dispactch(handleRestrictKey(loginresponse?.data?.restrict))
                setIsSideBar(loginresponse?.data?.restrict)

                // Show duplicate session modal
                setloading(false)
                setDuplicateTabModal(true)
                return // Stop further processing
            }

            // This should only run if duplicateTabModal is false (no duplicate session)
            if (!duplicateTabModal && loginresponse?.data?.Preference_list && loginresponse.data?.Preference_list?.length > 0) {

                setPreferenceModel(true)

                sessionStorage.setItem('session_token', loginresponse?.data?.session_token);

                sessionStorage.setItem('user_type', loginresponse?.data?.user_type);
                setPreferenceList(loginresponse.data.Preference_list)
                // Sync auth tokens to localStorage for cross-tab access
                syncAuthToLocalStorage();
                setloading(false);

                return
            } else {
                if (loginresponse.error) {
                    seterror(true);
                    setloginError(loginresponse.message.response.data.message)
                    setloading(false);
                } else {
                    sessionStorage.setItem('email', email);
                    sessionStorage.setItem('IdToken', loginresponse?.data?.IdToken)
                    sessionStorage.setItem('currentTimestamp', ((new Date).getTime().toString()))
                    sessionStorage.setItem('RefreshToken', loginresponse?.data?.RefreshToken)
                    sessionStorage.setItem('AccessToken', loginresponse?.data?.AccessToken)
                    sessionStorage.setItem('user_id', loginresponse?.data?.user_id)
                    sessionStorage.setItem('id', loginresponse?.data?.id);
                    sessionStorage.setItem('user_type', loginresponse?.data?.user_type);
                    // Sync auth tokens to localStorage for cross-tab access
                    syncAuthToLocalStorage();
                    if ((loginresponse?.data?.restrict === false && loginresponse?.data?.trust_my_browser === true) || loginresponse?.data?.restrict === false) {
                        dispactch(logIn());
                        setIsSideBar(false)
                        refreshIdToken()
                        WebSocketConnection()
                        setInterval(handleRefreshToken, 9 * 60 * 1000);
                        setToastmessage('Login successful')
                        navigate('/profile')
                        if(localStorage.getItem('arcm_trust_browser_token') !== null ){
                            fetchAndCacheHelpGuides();
                        }
                        return
                    }
                    if (loginresponse?.data?.restrict === "true" || loginresponse?.data?.restrict === true) {
                        dispactch(handleRestrictKey(loginresponse?.data?.restrict))
                        setIsSideBar(loginresponse?.data?.restrict)
                        sessionStorage.setItem('user_type', loginresponse?.data?.user_type);
                        dispactch(logIn());
                        WebSocketConnection()
                        setToastmessage('Login successful')
                        refreshIdToken()
                        authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''), password)
                        setInterval(handleRefreshToken, 9 * 60 * 1000);
                        navigate('/profile')
                        return
                    }
                    if (loginresponse.data.is_reset_password === false || loginresponse.data.status === 'reset') {
                        refreshIdToken()
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        sessionStorage.setItem('custom:is_first_time_login', true);
                        sessionStorage.setItem('user_type', loginresponse?.data?.user_type);
                        setToastmessage('Login successful')
                        navigate('/reset')
                        return
                    }
                    // setToastmessage('You’ve received an OTP to your registered email address or +91 xxxx-xxxxx')
                    setIsLoginPage(false);
                    setDisplayOtpScreen(true);
                    setloading(false);
                }
            }
        } catch (error) {
            if (error.code === "NotAuthorizedException") {
                setloginError(error.message)
            }
            else {
                setloginError(error.message?.split("error")[1])
            }

            seterror(true);
            setloading(false);

        }
    };

    const handleSelectPreference = async (item) => {
        setSelectedPreference(item)
    }

    const handleRefreshToken = async () => {
        if (sessionStorage.getItem('IdToken')) {
            refreshIdToken()
        }

    };


    const handleSendotptoPreference = async () => {
        setPreferenceLoading(true)
        const response = await userService.sendOtptoPreference(selectedPreference._id);
        if (response.error === false) {
            sessionStorage.setItem('verify_otp_session_token', response.data.verify_otp_session_token);
            sessionStorage.setItem('duration', response.data.otp_resend_duration);
            sessionStorage.setItem('preference_id', selectedPreference._id);
            setToastmessage(`You’ve been sent an OTP to ${selectedPreference.otp_preference_mode === 'email'
                ? maskValue(selectedPreference.preference)
                : `${selectedPreference?.country_code} ${selectedPreference?.preference?.slice(0, 2) +
                '*'.repeat(selectedPreference?.preference?.length - 4) +
                selectedPreference?.preference?.slice(-2)}`
            }`)
            setDisplayOtpScreen(true)
            setIsLoginPage(false)
            setPreferenceLoading(false)
            setPreferenceModel(false)
        } else {
            setPreferenceLoading(false)
            setToastErrorMessage(response.message)
            // setDisplayOtpScreen(true)
            // setPreferenceModel(false)
        }
    }

    const handleClose = () => {
        setPreferenceModel(false)
        setPreferenceLoading(false)
        setSelectedPreference([])
    }

    // Duplicate tab closing fun below

    const handleAllowDuplicateTabClose = async () => {

        if (loginData?.data?.Preference_list === undefined && loginData?.data?.isLoggedIn === true) {
            setDupLoadingBtn(true)

            sessionStorage.setItem('email', email);
            sessionStorage.setItem('IdToken', loginData?.data?.IdToken)
            sessionStorage.setItem('currentTimestamp', ((new Date).getTime().toString()))
            sessionStorage.setItem('RefreshToken', loginData?.data?.RefreshToken)
            sessionStorage.setItem('AccessToken', loginData?.data?.AccessToken)
            sessionStorage.setItem('user_id', loginData?.data?.user_id)
            sessionStorage.setItem('id', loginData?.data?.id);
            sessionStorage.setItem('user_type', loginData?.data?.user_type);
            sessionStorage.setItem('session_token', loginData?.data?.session_token);



            await userService.DuplicateTabClose('');

            setDuplicateTabModal(false);
            refreshIdToken()
            setInterval(handleRefreshToken, 9 * 60 * 1000);
            navigate('/profile');
            WebSocketConnection()

        }
        else {
            setDuplicateTabModal(false)
            setPreferenceModel(true)
        }
    }

    const handleDuplicateModalClose = async () => {
        setPreferenceModel(false)
        setDuplicateTabModal(false)
        
        // Clear all auth data when user clicks "No" to prevent auto-login on refresh
        clearAuthData();
        
        const DuplicateTabCancelRes = await userService.CancelDuplicatelogin('')
    }

    return (
        <>
            <div className='flex bg-white'>
                {!isTrustMyBrowser && <BannerImage />}
                {!isForgotPassword && IsLoginPage && !displayOtpScreen && !isTrustMyBrowser && <SignIn
                    setIsLoginPage={setIsLoginPage}
                    email={email}
                    emptyError={emptyError}
                    setEmptyError={setEmptyError}
                    handleLoginCredentilas={handleLoginCredentilas}
                    error={error}
                    loginError={loginError}
                    seterror={seterror}
                    password={password}
                    loading={loading}
                    setIsForgotPassword={setIsForgotPassword}
                    handleLogin={handleLogin}
                />}
                {duplicateTabModal &&
                    <DuplicateTabCloseModal
                        tittle={'Duplicate Session?'}
                        buttonName={'Yes'}
                        message={'You are already logged in through another system. Do you want to end the other session and login here?'}
                        handleAllowDuplicateClose={handleAllowDuplicateTabClose}
                        handleClose={handleDuplicateModalClose}
                        dupLoadingBtn={dupLoadingBtn}
                        data_testid={"continue-btn"}
                        CancelButton={true}
                    />
                }
                {!IsLoginPage && displayOtpScreen && <OtpPage
                    selectedPreference={selectedPreference}
                    setIsTrustMyBrowser={setIsTrustMyBrowser}
                    setSelectedPreference={setSelectedPreference}
                    setloginCredentials={setloginCredentials}
                    setIsLoginPage={setIsLoginPage}
                    handleLogin={handleLogin}
                    duration={duration}
                    userData={userData}
                    setOtp={setOtp}
                    otp={otp}
                    setIsForgotPassword={setIsForgotPassword}
                    // handelClear={handleClear}
                    displayOtpScreen={displayOtpScreen}
                    setDisplayOtpScreen={setDisplayOtpScreen}
                    setPreferenceModel={setPreferenceModel}
                    preferenceModel={preferenceModel}
                    loginCredentials={loginCredentials}
                    loginData={loginData}

                />
                }
                {isForgotPassword && IsLoginPage &&
                    <ForgotPassword
                        setIsForgotPassword={setIsForgotPassword}
                        handelClear={handelClear}
                        email={email}
                        emptyError={emptyError}
                        setEmptyError={setEmptyError}
                        error={error}
                        loginError={loginError}
                        seterror={seterror}
                        loading={loading}
                        setloading={setloading}
                    />}
                {preferenceModel && !duplicateTabModal &&
                    <SetPreferencesModal
                        tittle={'Verify your Identity'}
                        buttonName={'Send'}
                        message={'Select your preference to receive the verification code'}
                        preferenceList={preferenceList}
                        isDropdownOpen={isDropdownOpen}
                        setIsDropdownOpen={setIsDropdownOpen}
                        handleSelectPreference={handleSelectPreference}
                        handleSendotptoPreference={handleSendotptoPreference}
                        selectedPreference={selectedPreference}
                        handleClose={handleClose}
                        setPreferenceLoading={setPreferenceLoading}
                        preferenceLoading={preferenceLoading}
                    />
                }
                {
                    isTrustMyBrowser &&
                    <TrustBrowser
                        setIsTrustMyBrowser={setIsTrustMyBrowser} />
                }
            </div>
        </>
    )
}
